import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getOpcoOrganizationUsersPath = (id: string = ':id') => urlHelper(`/organization/${id}/users`);
